<template>
  <div id="map-view">
    <div id="map"></div>
  </div>
</template>
<script>
import _ from "lodash";
import moment from "moment";
import "moment/locale/th";
import { mapState, mapGetters } from "vuex";
import gmapsInit from "@/gmap/gmaps";
import { VESSELS_TYPE } from "../../constants";
import { chartOptions } from "./chart";
import { refinery } from "./location";
import all from "../../milesSea/all.json";

export default {
  components: {
  },
  name: "MapView",
  props: {
    type: {
      type: String,
      default: VESSELS_TYPE.EXCISE,
    },
    config: {
      type: Object,
      default: () => {},
    },
    transfers: {
      type: Array,
    },
  },
  data() {
    return {
      active: false,
      google: null,
      windowInfo: null,
      zoom: 7,
      markers: [],
      vesselTankerDetail: {},
      chartOptions: chartOptions,
      refinery,
      transferData: [],
      all,
    };
  },
  computed: {
    ...mapState({
      dataRts: (state) => state.rts.vessels,
      loading: (state) => state.rts.loading,
      selectNode: (state) => state.rts.selectNode,
      station: (state) => state.mpTankerData.mpStation,
      dataVessel: (state) => state.monitoring.dataVessel,
    //   error: (state) => state.vesselTanker.error,
    }),
  },
  watch: {
    loading(val) {
      if (val) {
        this.$vs.loading();
      } else {
        this.$vs.loading.close();
      }
    },
    async dataRts(val) {
      if (_.isEmpty(val)) {
        return;
      }
      await this.panTo(this.station)
      await this.renderVessel(val);
    },
    selectNode(val, oldval) {
      if (!_.isEqual(val, oldval) && val) {
        this.panTo(val);
      }
    },
    station(val, oldval) {
      if (!_.isEqual(val, oldval)) {
        this.panTo(val);
      }
    },
    // windowInfo(val, oldval) {
    //   console.log(val, oldval);
    //   if (!val.map) {
    //     const latitude = 12.7772995;
    //     const longitude = 100.5255274;
    //     const latlng = new google.maps.LatLng(latitude, longitude);
    //     this.map.panTo(latlng);
    //     this.map.setZoom(9);
    //   }
    // },
  },
  async mounted() {
    // console.log("dataVessel >>>>> ", this.dataVessel);
    await this.initGoogleMap();
    await this.$store.dispatch("rts/getRtsVessel", { type: this.type });
  },
  methods: {
    async initGoogleMap() {
      const google = await gmapsInit();
      this.geocoder = new google.maps.Geocoder();
      const latlng = new google.maps.LatLng(12.7772995, 100.5255274);
      const options = {
        zoom: this.zoom,
        center: latlng,
        streetViewControl: false,
        mapTypeControl: false,
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        fullscreenControl: true,
        gestureHandling: "greedy",
        zoomControl: true,
      };
      this.map = new google.maps.Map(this.$el.querySelector("#map"), options);
      this.google = google;

      this.map.data.addGeoJson(this.all);
      this.map.data.setStyle((feature) => {
        var color = feature.getProperty("color");
        if (color == "red") {
          color = "red";
        } else if (color == "green") {
          color = "#10FD1E";
        } else if (color == "blue") {
          color = "#00BDFF";
        }
        return {
          clickable: false,
          fillColor: color,
          strokeWeight: 0,
        };
      });

      // render refinaty
      this.renderRefinery();
    },
    renderRefinery() {
      for (let i = 0; i < this.refinery.length; i++) {
        const latitude = this.refinery[i].latitude;
        const longitude = this.refinery[i].longitude;

        const { google, map } = this;
        const latlng = new google.maps.LatLng(latitude, longitude);
        const imageUrl = this.refinery[i].imageUrl;
        const markerImage = this.createMarkerIcon(imageUrl);

        const marker = new google.maps.Marker({
          position: latlng,
          map,
          icon: markerImage,
          detail: { ...this.refinery[i] },
        });
        this.markers.push(marker);
      }
    },
    createMarkerIcon(imageUrl) {
      const google = this.google;
      const markerImage = new google.maps.MarkerImage(
        imageUrl,
        new google.maps.Size(30, 30),
        new google.maps.Point(0, 0),
        new google.maps.Point(20, 20),
        new google.maps.Size(30, 30)
      );
      return markerImage;
    },
    renderVessel(val) {
      const { google, map } = this;
      val.map((vessel, i) => {
        const latitude = _.get(vessel, "latitude");
        const longitude = _.get(vessel, "longitude");
        const latlng = new google.maps.LatLng(latitude, longitude);

        const imageUrl = this.getVesselImg(vessel);
        const markerImage = this.createMarkerIcon(imageUrl);

        const marker = new google.maps.Marker({
          position: latlng,
          map,
          icon: markerImage,
          detail: { ...vessel, idg: i },
        });
        const vm = this;
        google.maps.event.addListener(marker, "click", function () {
          vm.openLoading();
          map.setZoom(10);
          map.setCenter(marker.getPosition());
          vm.active = true;
          vm.vesselTankerDetail = marker.detail;

          vm.windowInfoClose();
          vm.windowInfo = new google.maps.InfoWindow({
            content: marker.detail.name,
            position: marker.getPosition(),
          });
          vm.windowInfo.open(vm.map);

        });
        this.markers.push(marker);
      });
    },
    getVesselImg(vessel) {
      const imgShip = "excise";
      const direction = _.get(vessel, "hdg_cog", 360);
      const shipType = vessel.navigation_status_code == "0" ? "b" : "";
      const imgDirection = this.getDirection(direction);
      const imageUrl = `/assets/markers/${imgShip}/${shipType}${imgDirection}.png`;
      return imageUrl;
    },
    getDirection(direction) {
      const n = direction % 10 ? 0 : 1;
      const tpye = Math.ceil(direction / 10) + n;
      return tpye > 36 ? 10 : tpye;
    },
    panTo(data) {
      const google = this.google;
      this.markers.map((val) => {
        const { detail } = val;

        if (data.mmsi) {
          if (detail.mmsi == data.mmsi) {
            this.map.panTo(val.getPosition());
            this.map.setZoom(10);
            this.windowInfoClose();
            this.windowInfo = new google.maps.InfoWindow({
              content: detail.name,
              position: val.getPosition(),
            });
            this.windowInfo.open(this.map);
          }
        } else if (data.name_en) {
          if (detail.name == data.name_en) {
            this.map.panTo(val.getPosition());
            this.map.setZoom(10);
            this.windowInfoClose();
            this.windowInfo = new google.maps.InfoWindow({
              content: detail.name,
              position: val.getPosition(),
            });
            this.windowInfo.open(this.map);
          }
        } else {
          console.log(data.member_code);
        }

        
      });
    },
    windowInfoClose() {
      if (this.windowInfo) {
        this.windowInfo.close();
      }
    },
    openLoading() {
      this.$vs.loading();
      setTimeout(() => {
        this.$vs.loading.close();
      }, 1000);
    },
  },
};
</script>
<style scoped>
#map {
  position: relative;
  width: 100%;
  height: 100%;
}
#map-view {
  width: 100%;
  height: 100%;
}
</style>
